import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">AI Innovations at the Edge</p>
        <p className="chapter__paragraph">
          After a decade or more of moving to the cloud to streamline and scale operations and
          improve customer experiences, businesses are now exploring a new frontier: the edge.
          That’s why the combination of edge and cloud computing scores high on McKinsey & Company’s{' '}
          <a
            href="https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/the-top-trends-in-tech"
            target="_blank"
            rel="sponsored"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            list
          </a>{' '}
          of the top 14 most significant technology trends of 2022. Also high on the list—at the
          very top for speed of innovation and amount of investment—is AI. It’s no coincidence. The
          edge and AI go hand-in-hand.
        </p>
        <p className="chapter__paragraph">
          The edge means business-and-industrial-scale computing taking place on-site and away from
          traditional, big-ticket data centers and cloud infrastructure. It’s made possible by
          hardware and software advances that shrink the computational power of yesterday’s
          mainframes into intelligent and affordable devices that are no bigger than shoeboxes.
        </p>
        <p className="chapter__paragraph">
          Now, even the manager of a small retail store can command the power of artificial
          intelligence from their desk, on-site or off. “It is relatively heavy in terms of
          computing and is not something your average laptop can pull off,” Shaw says of his
          company’s advanced AI algorithms. “Some retailers have [dedicated server rooms], but then
          there are retailers running analytics on a computer under the manager’s desk. We have to
          support both.”
        </p>
      </section>
    </>
  );
}

export default Chapter3;
